import { useRef, useEffect, forwardRef } from 'react';
import mergeRefs from 'react-merge-refs';
import { StyledModalEditableBody } from './styled';

const ModalEditableBody = forwardRef((props, ref) => {
  const localRef = useRef();

  useEffect(() => {
    const top = props.modalRef?.current.scrollTop;
    const left = props.modalRef?.current.scrollLeft;

    localRef.current.style.height = '0px';
    localRef.current.style.height = localRef.current.scrollHeight + 'px';

    props.modalRef?.current.scrollTo(left, top);
  }, [props.value]);

  return (
    <StyledModalEditableBody ref={mergeRefs([localRef, ref])} {...props} />
  );
});

ModalEditableBody.defaultProps = {
  style: {
    height: '0px',
  },
  placeholder: 'Write here',
};

export default ModalEditableBody;
